import { h, VNode, FunctionComponent, toChildArray } from "preact"; /** @jsx h */

import { ICategory } from '@pyqml/model';
import { ROUTES } from '@pyqml/shared';

import { Authored, IAuthoredProps } from "../List/Authored";

import { useEnvironment } from "../../app/Environment";

export type IHeaderProps = {
	
    title: string;
	subtitle: string;
	categories: Array<ICategory>;
	abstractImage: string; // ./assets/img/demo/home.jpg
} & IAuthoredProps;

export const Header = (props: IHeaderProps) => {
	const { baseUrl, subdomain } = useEnvironment();



    return (
		<div className="container">
			<div className="jumbotron jumbotron-fluid mb-3 pl-0 pt-0 pb-0 bg-white position-relative">
				<div className="h-100 tofront">
					<div className="row justify-content-between">
						<div className="col-md-6 pt-6 pb-6 align-self-center">
							<p className="text-uppercase font-weight-bold">
								{
									props?.categories?.filter(category => !(!category)).map((category: ICategory) => (
										<a
											className="text-danger mr-2"
											href={`${baseUrl}${ROUTES.BLOG_CATEGORY}/${category.categorySlug}`}
											
										>
											{ category.categoryName }
										</a>
									))
								}
								
							</p>
							<h1 className="display-4 secondfont mb-3 font-weight-bold">{props.title}</h1>
							<p className="mb-3">
								{props.subtitle}
							</p>
							<Authored {...props} />
						</div>
						{ props.abstractImage && <div className="col-md-6 pr-0">
							<img src={ `/${subdomain}/${props.abstractImage}`}></img>
						</div> }
					</div>
				</div>
			</div>
		</div>
	);
}
